exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-brand {\n\twidth: 157px;\n\tbackground-image: url(/static/daupler/img/new_logo.png);\n\tbackground-repeat: no-repeat;\n\tbackground-size: 144px 40px;\n\tbackground-position: 15px 12px;\n}\n\n.navbar-nav>li>a {\n\tfont-size: 14px;\n}\n", ""]);

// exports
